export default "__VITE_ASSET__CJgJrxbb__"